module.exports = __webpack_public_path__ + "PH.png?f787e5ef184594cb13d64e286a97b0c5";